import { render, staticRenderFns } from "./PrivacyHistoryItems.vue?vue&type=template&id=fb8c5ac4&scoped=true"
import script from "./PrivacyHistoryItems.vue?vue&type=script&lang=js"
export * from "./PrivacyHistoryItems.vue?vue&type=script&lang=js"
import style0 from "./PrivacyHistoryItems.vue?vue&type=style&index=0&id=fb8c5ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c5ac4",
  null
  
)

export default component.exports